import { BasicDetails } from "./BasicDetails";

export function Profile() {

    return (
        <div className="">

            <BasicDetails />
        </div>
    );
}